export const fieldsValid = (aiTVShow) => {
  return typeof aiTVShow?.title === "string" && aiTVShow.title.trim() !== "";
};

/**
 * Sometimes the AI services return empty results. This filter ensures
 * that they are not rendered.
 */
export const filterTMDBTVShows = (aiTVShows) => {
  return aiTVShows?.filter((aiTVShow) => fieldsValid(aiTVShow));
};
